import { env } from '@/config/env'

export type SearchParams = Record<string, string | number | boolean | undefined>

export function buildUrl(path: string, searchParams?: SearchParams): string {
  const base = path.startsWith('http') ? path : `${env.apiBaseUrl}${path}`
  if (!searchParams) return base

  const url = new URL(base, window.location.origin)
  for (const [key, value] of Object.entries(searchParams)) {
    if (value !== undefined) url.searchParams.set(key, String(value))
  }
  return url.toString()
}
